export var templates = [
    { id: 'angels-eye',
        key: 'template-1',
        thumbnail: 'https://d2x3xhvgiqkx42.cloudfront.net/12345678-1234-1234-1234-1234567890ab/2016/11/08/cf54ce93-dc97-40d9-b323-d8a11d8997eb.png',
        thumbnailx2: 'https://d2x3xhvgiqkx42.cloudfront.net/12345678-1234-1234-1234-1234567890ab/2016/11/08/5367c05c-fe63-4c70-809e-109c3c623461.png'
    },
    { id: 'teralabs',
        key: 'template-2',
        thumbnail: 'https://d2x3xhvgiqkx42.cloudfront.net/12345678-1234-1234-1234-1234567890ab/2016/11/08/a6f55e1f-774a-40fe-a82e-493f0e6680ea.png',
        thumbnailx2: 'https://d2x3xhvgiqkx42.cloudfront.net/12345678-1234-1234-1234-1234567890ab/2016/11/08/4d84c132-6932-43d9-898d-3e1747d88ea3.png'
    },
    { id: 'tiny',
        key: 'template-3',
        thumbnail: 'https://d2x3xhvgiqkx42.cloudfront.net/12345678-1234-1234-1234-1234567890ab/2016/11/08/6d9c4b86-dd6d-4715-b19b-e34b00ccb65a.png',
        thumbnailx2: 'https://d2x3xhvgiqkx42.cloudfront.net/12345678-1234-1234-1234-1234567890ab/2016/11/08/7a0e19b6-e354-49b9-b783-1bb0b306b8b6.png'
    }
];
//# sourceMappingURL=template-types.js.map